import { useQuery } from "@tanstack/react-query";

import { MediaCatalogueItem } from "../../models/MediaCatalogueItem";
import DataSvc from "../../services/dataSvc";

const useLocationMediaCatalogueList = (locationId: string) => {
  const query = useQuery<MediaCatalogueItem[]>(
    ["location.mediaCatalogue", locationId],
    async () => {
      if (!locationId) return [];
      const result = await DataSvc.getMediaCatalogue(locationId, {
        limit: 10,
        offset: 0,
        order: "desc",
        sort: "created_at",
      });
      return Array.isArray(result?.items) ? result.items : [];
    }
  );

  return query;
};

export default useLocationMediaCatalogueList;
